export const AGORA_APPID = '1cbff07b862b48e887dae922cd2d887f'
export const AGORA_CERTIFICATE = '657d29c651a641bc8c4acb7a3018d2ad'
